import { jsx as _jsx } from "react/jsx-runtime";
import { Form as HeroForm } from '@heroui/react';
export const Form = (props) => {
    return _jsx(HeroForm, { ...props });
};
export default Form;
//# sourceMappingURL=Form.js.map